import { paxios } from 'util/axiosprgs';
import {
  PolicyDetailRes,
  PolicyListReq,
  PolicyVersionRes,
  PolicyCreateReq,
  PolicyUpdateReq,
} from '../types/policy.types';

export const usePolicyApi = () => {
  const getGuestPolicyDetail = async (id: number): Promise<PolicyDetailRes> => {
    const response = await paxios.get(`/api/guest/zdata/policy/${id}`);
    return response.data.data;
  };

  const getAdminPolicyDetail = async (id: number): Promise<PolicyDetailRes> => {
    const response = await paxios.get(`/api/boris/zdata/policy/${id}`);
    return response.data.data;
  };

  const getAdminPolicyList = async (param: PolicyListReq): Promise<PolicyVersionRes[]> => {
    const response = await paxios.post(`/api/boris/zdata/policy/list`, param);
    return response.data.data;
  };

  const getGuestPolicyList = async (param: PolicyListReq): Promise<PolicyVersionRes[]> => {
    const response = await paxios.post(`/api/guest/zdata/policy/list`, param);
    return response.data.data;
  };

  const createPolicy = async (param: PolicyCreateReq): Promise<number> => {
    const response = await paxios.post(`/api/boris/zdata/policy/create`, param);
    return response.data.data;
  };

  const updatePolicy = async (id: number, param: PolicyUpdateReq): Promise<number> => {
    const response = await paxios.put(`/api/boris/zdata/policy/update/${id}`, param);
    return response.data.data;
  };

  const deletePolicy = async (id: number): Promise<void> => {
    await paxios.delete(`/api/boris/zdata/policy/delete/${id}`);
  };

  return {
    getGuestPolicyDetail,
    getAdminPolicyDetail,
    getAdminPolicyList,
    getGuestPolicyList,
    createPolicy,
    updatePolicy,
    deletePolicy,
  };
};
